import HTTP from '@/plugins/http';

const sysConfigApi = {
  configList: '/sys/config/list',
  configUpdate: '/sys/config/update',
};
//  获取列表
function getSysConfigList({ data }) {
  return HTTP.loading({
    url: sysConfigApi.configList,
    method: 'post',
    data
  });
}
// 修改配置
function configUpdate(params) {
  return HTTP({
    url: sysConfigApi.configUpdate,
    method: 'post',
    data: params
  });
}
// function getPage({ data, params }) {
//   return HTTP.loading({
//     url: channelApi.userPage,
//     method: 'post',
//     data,
//     params
//   });
// }
//
//
//
// function userUpdate(params) {
//   return HTTP({
//     url: channelApi.userUpdate,
//     method: 'post',
//     data: params
//   });
// }
// function confAdd(params) {
//   return HTTP({
//     url: channelApi.confAdd,
//     method: 'post',
//     data: params
//   });
// }
// function confPage({ data, params }) {
//   return HTTP({
//     url: channelApi.confPage,
//     method: 'post',
//     data,
//     params
//   });
// }
// function confType() {
//   return HTTP({
//     url: channelApi.confType,
//     method: 'get',
//     'content-type': 'application/x-www-form-urlencoded'
//   });
// }
// function doTest(data) {
//   return HTTP.loading({
//     url: data.type != 'usdt_qr'? channelApi.test: channelApi.testUsdt,
//     method: 'post',
//     data
//   });
// }
// function confUpdate(params) {
//   return HTTP({
//     url: channelApi.confUpdate,
//     method: 'post',
//     data: params
//   });
// }
//
// function channelUpdate(params) {
//   return HTTP({
//     url: channelApi.updateChannelType,
//     method: 'post',
//     data: params
//   });
// }

export default {
  getSysConfigList,
  configUpdate,
  // getPage,
  // userUpdate,
  // confAdd,
  // confPage,
  // confType,
  // confUpdate,
  // doTest,
  // channelUpdate
};



// WEBPACK FOOTER //
// ./src/api/sysConfig.js